import React from "react";
import Bannerheader from "../pages/Bannerheader";
import { Footer } from "../navbar/Footer";

const ReturnRefundPolicy = () => {
  return (
    <>
      <Bannerheader />

      {/* Document Style Container */}
      <div className="bg-light py-4">
        <div className="container">
          {/* Document Paper Effect */}
          <div className="bg-white shadow rounded-3 overflow-hidden">
            {/* Document Header */}
            <div className="border-bottom p-4 p-md-5 text-center bg-danger bg-opacity-10">
              <div className="mb-3">
                <span className="bg-danger text-white px-3 py-2 rounded-3 fw-semibold small">
                  CUSTOMER PROTECTION POLICY
                </span>
              </div>
              <h1 className="display-5 fw-bold text-dark mb-3">
                Return & Refund Policy
              </h1>
            </div>

            {/* Document Content */}
            <div className="p-4 p-md-5">
              {/* Introduction */}
              <div className="mb-5">
                <div className="bg-danger bg-opacity-5 p-4 rounded-3 border-start border-danger border-4">
                  <p className="lead text-secondary mb-0">
                    We want you to be completely satisfied with your purchase
                    from Vogelkop Architects. This policy outlines the terms and
                    conditions for returns, refunds, and exchanges.
                  </p>
                </div>
              </div>

              {/* Quick Summary Cards */}
              <div className="row g-4 mb-5">
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-center p-4">
                      <div
                        className="bg-success bg-opacity-10 text-success rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{ width: "60px", height: "60px" }}
                      >
                        <i className="bi bi-arrow-return-left fs-2"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Return Window</h5>
                      <p className="display-6 fw-bold text-success mb-2">
                        7 Days
                      </p>
                      <small className="text-muted">From delivery date</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-center p-4">
                      <div
                        className="bg-info bg-opacity-10 text-info rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{ width: "60px", height: "60px" }}
                      >
                        <i className="bi bi-cash-stack fs-2"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Refund Timeline</h5>
                      <p className="display-6 fw-bold text-info mb-2">
                        7-10 Days
                      </p>
                      <small className="text-muted">After approval</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-center p-4">
                      <div
                        className="bg-warning bg-opacity-10 text-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{ width: "60px", height: "60px" }}
                      >
                        <i className="bi bi-exclamation-triangle fs-2"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Non-Returnable</h5>
                      <p className="fw-bold text-warning mb-2">Custom Items</p>
                      <small className="text-muted">
                        Furniture & special orders
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 1 - Return Eligibility */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">1</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Return Eligibility</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-3">
                    Customers can request a return within{" "}
                    <strong className="text-danger">7 days of delivery</strong>{" "}
                    under the following conditions:
                  </p>

                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <div className="d-flex p-3 border rounded-3">
                        <i className="bi bi-check-circle-fill text-success me-3 fs-4"></i>
                        <div>
                          <h6 className="fw-bold mb-1">Damaged Products</h6>
                          <p className="small text-secondary mb-0">
                            Items damaged during shipping or delivery
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex p-3 border rounded-3">
                        <i className="bi bi-check-circle-fill text-success me-3 fs-4"></i>
                        <div>
                          <h6 className="fw-bold mb-1">Defective Items</h6>
                          <p className="small text-secondary mb-0">
                            Manufacturing defects or quality issues
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex p-3 border rounded-3">
                        <i className="bi bi-check-circle-fill text-success me-3 fs-4"></i>
                        <div>
                          <h6 className="fw-bold mb-1">Wrong Item Delivered</h6>
                          <p className="small text-secondary mb-0">
                            Product different from what was ordered
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex p-3 border rounded-3">
                        <i className="bi bi-check-circle-fill text-success me-3 fs-4"></i>
                        <div>
                          <h6 className="fw-bold mb-1">Missing Parts</h6>
                          <p className="small text-secondary mb-0">
                            Incomplete shipment or missing components
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 2 - Non-Returnable Items */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">2</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Non-Returnable Items</h2>
                </div>

                <div className="ps-md-5">
                  <div className="row">
                    <div className="col-lg-7">
                      <div className="bg-light p-4 rounded-3 mb-3 mb-lg-0">
                        <h6 className="fw-bold text-warning mb-3">
                          <i className="bi bi-exclamation-octagon me-2"></i>
                          The following items cannot be returned:
                        </h6>
                        <ul className="list-unstyled">
                          <li className="mb-2 d-flex">
                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                            <span>Customized furniture items</span>
                          </li>
                          <li className="mb-2 d-flex">
                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                            <span>Made-to-order products</span>
                          </li>
                          <li className="mb-2 d-flex">
                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                            <span>Items with custom measurements</span>
                          </li>
                          <li className="mb-2 d-flex">
                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                            <span>Personalized or engraved items</span>
                          </li>
                          <li className="mb-2 d-flex">
                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                            <span>Items damaged due to misuse</span>
                          </li>
                          <li className="d-flex">
                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                            <span>Products beyond 7-day window</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="card border-warning bg-warning bg-opacity-5 h-100">
                        <div className="card-body p-4 text-center">
                          <i className="bi bi-cone-striped fs-1 text-warning mb-3"></i>
                          <h6 className="fw-bold mb-2">Important Note</h6>
                          <p className="small text-secondary mb-0">
                            Customized furniture items are specifically
                            manufactured according to your requirements and
                            cannot be resold, making them non-returnable unless
                            defective.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 3 - Return Process */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">3</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Return Process</h2>
                </div>

                <div className="ps-md-5">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="text-center">
                        <div
                          className="bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                          style={{ width: "50px", height: "50px" }}
                        >
                          <span className="fw-bold">1</span>
                        </div>
                        <h6 className="fw-bold small">Initiate Return</h6>
                        <p className="small text-secondary">
                          Email support within 7 days
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <div
                          className="bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                          style={{ width: "50px", height: "50px" }}
                        >
                          <span className="fw-bold">2</span>
                        </div>
                        <h6 className="fw-bold small">Get Approval</h6>
                        <p className="small text-secondary">
                          24-48 hours review time
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <div
                          className="bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                          style={{ width: "50px", height: "50px" }}
                        >
                          <span className="fw-bold">3</span>
                        </div>
                        <h6 className="fw-bold small">Ship Item</h6>
                        <p className="small text-secondary">
                          Use original packaging
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <div
                          className="bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                          style={{ width: "50px", height: "50px" }}
                        >
                          <span className="fw-bold">4</span>
                        </div>
                        <h6 className="fw-bold small">Receive Refund</h6>
                        <p className="small text-secondary">
                          7-10 business days
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 4 - Refund Information */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">4</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Refund Information</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-3">
                    Refunds will be processed within{" "}
                    <strong>7-10 business days</strong> after return approval:
                  </p>

                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Refund Type</th>
                          <th>Timeline</th>
                          <th>Method</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Original Payment</td>
                          <td>7-10 business days</td>
                          <td>Source account</td>
                          <td>Credit/debit card, UPI, netbanking</td>
                        </tr>
                        <tr>
                          <td>Store Credit</td>
                          <td>24-48 hours</td>
                          <td>Gift card/voucher</td>
                          <td>Valid for 1 year</td>
                        </tr>
                        <tr>
                          <td>Partial Refund</td>
                          <td>5-7 business days</td>
                          <td>Based on condition</td>
                          <td>For used/damaged returns</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-3 bg-light p-3 rounded-3">
                    <small className="text-secondary">
                      <i className="bi bi-info-circle me-2 text-primary"></i>
                      Refund timelines may vary based on your bank's processing
                      time.
                    </small>
                  </div>
                </div>
              </section>

              {/* Section 5 - Conditions & Requirements */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">5</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Return Conditions</h2>
                </div>

                <div className="ps-md-5">
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item bg-transparent">
                          <i className="bi bi-check-lg text-success me-2"></i>
                          Item must be in original condition
                        </li>
                        <li className="list-group-item bg-transparent">
                          <i className="bi bi-check-lg text-success me-2"></i>
                          Original packaging required
                        </li>
                        <li className="list-group-item bg-transparent">
                          <i className="bi bi-check-lg text-success me-2"></i>
                          All tags and labels attached
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item bg-transparent">
                          <i className="bi bi-check-lg text-success me-2"></i>
                          Proof of purchase required
                        </li>
                        <li className="list-group-item bg-transparent">
                          <i className="bi bi-check-lg text-success me-2"></i>
                          Photos of damage/defect needed
                        </li>
                        <li className="list-group-item bg-transparent">
                          <i className="bi bi-check-lg text-success me-2"></i>
                          Return shipping paid by customer*
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="small text-secondary mt-2">
                    * Free return shipping for damaged/defective items
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Icons */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />

      {/* Custom Styles */}
      <style jsx>{`
        .bg-opacity-5 {
          background-color: rgba(var(--bs-danger-rgb), 0.05) !important;
        }
      `}</style>

      <Footer />
    </>
  );
};

export default ReturnRefundPolicy;
